import { Component, Host, h, Prop } from '@stencil/core';
@Component({
  tag: 'cms-price',
  styleUrl: 'cms-price.scss',
  shadow: true,
})
export class CmsPrice {

  /**
   * Set the price of the article like 10,00
   */
  @Prop() price: string;

  /**
   * Set the price-unit of the article like 'Stck.'
   */
  @Prop() unit: string;

  /**
   * Set the currency of the article like '€'
   */
  @Prop() currency: string;

  /**
   * Set the prefix of the article like 'ab'
   * 'prefix' can't be used as Prop, cause it's a reserved word
   */
  @Prop() pricePrefix?: string;

  /**
   * Set the bracket price of the article like 10,00
   **/
  @Prop() bracketPrice?: string;

  /**
   * Set the bracket price-unit of the article like 'Stck.'
   **/
  @Prop() bracketPriceUnit?: string;

    /**
   * Set the size of the price - only affects the font-size of .price
   * XS: Brandfont1-112
   * SM: Brandfont1-150
   * MD: Brandfont1-187
   * LG: Brandfont1-225
   */
    @Prop() size: string = 'MD';


  render() {
    const currencyLabel = this.currency ? `&nbsp;${this.currency}*` : '';
    return (
      <Host class={`${this.size.toLowerCase()}`}>
        <div class={'article-price'}>
              {this.pricePrefix ? (
                <span class='prefix'>
                  {this.pricePrefix}&nbsp;
                </span>
              ) : (
                ''
              )}
              <span class='price' innerHTML={`${this.price}${currencyLabel}`}></span>
              {this.unit ? (
                <span class='unit'>
                  /&nbsp;{this.unit}
                </span>
              ) : (
                ''
              )}
              {this.bracketPrice && this.bracketPriceUnit ? (
                <span class={'bracket'}>
                  ({this.bracketPrice}&nbsp;{this.currency}*/&nbsp;{this.bracketPriceUnit})
                </span>
              ) : (
                ''
              )}
            </div>
      </Host>
    );
  }
}
